/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AutomatedProcessTerminate$Params {
  processInstanceId: string;
  reason?: string|null|undefined;
}

export function automatedProcessTerminate(http: HttpClient, rootUrl: string, params: AutomatedProcessTerminate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessTerminate.PATH, 'delete');
  if (params) {
    rb.path('processInstanceId', params.processInstanceId, {});
    rb.query('reason', params.reason, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

automatedProcessTerminate.PATH = '/automated-process/process-instance/{processInstanceId}/terminate';